import { render, staticRenderFns } from "./appMain.vue?vue&type=template&id=308bc85b&"
import script from "./appMain.vue?vue&type=script&lang=ts&"
export * from "./appMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports